<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-title>PMS Info for {{pmsConnDetails.usr}}</v-card-title>
          <v-card-subtitle>{{pmsConnDetails.pmsType}} | Retrieved from customer PMS: 
                                <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
            <timeago :datetime="pmsInfo.ctdTs" :auto-update="60"></timeago>
                        </span>
                      </template>
                      <span>
                        {{new Date(pmsInfo.ctdTs)}}
                      </span>
                                </v-tooltip>
 </v-card-subtitle>
          <json-viewer :expand-depth="1" copyable boxed sort :value="pmsInfo" expanded></json-viewer>

          <v-card-actions>
            <v-btn
              @click="requestPmsInfoUpdate()"
              :loading="requestingPmsInfoUpdate"
              color="warning"
            >Request PMS Info Update</v-btn>
            <v-icon
              title="PMS Info Request Sent"
              v-show="pmsInfoUpdateRequested"
              color="primary"
              small
            >mdi-checkbox-marked-circle</v-icon>
            <v-spacer></v-spacer>
            <v-btn @click="getPMSInfo(sub)" color="primary" right :loading="loading">Refresh</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";

export default {
  props: {
    pmsConnDetails: Object,
  },
  data: function () {
    return {
      loading: false,
      requestingPmsInfoUpdate: false,
      pmsInfoUpdateRequested: false,
      pmsInfo: {},
      sub: "",
    };
  },
  created: async function () {
    this.sub = this.$route.params.sub;
    await this.getPMSInfo(this.sub);
  },
  methods: {
    async getPMSInfo(sub) {
      this.loading = true;
      try {
        // Simple query
        //const allStatus = await API.graphql(graphqlOperation(queries.listStatus));
        console.log({ msg: "getPMSInfo", sub });
        const pmsInfo = await API.graphql(
          graphqlOperation(queries.getPmsInfo, { sub: sub })
        );

        console.log("pmsInfo", pmsInfo);

        if ((pmsInfo?.data?.getPMSInfo?.usr ?? "") === "") {
          this.msg = "Can't retrieve PMS Info details";
          return;
        }

        const jsonObj = JSON.parse(
          JSON.parse(pmsInfo.data.getPMSInfo?.details)
        );

        //this.msg = status.data.getPMSInfo.usr;
        this.pmsInfo = jsonObj;

        console.log("parse pmsinfo", this.pmsInfo);
      } catch (err) {
        this.msg = err;
        this.items = {};
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async requestPmsInfoUpdate() {
      this.requestingPmsInfoUpdate = true;
      const taskRequest = await API.graphql(
        graphqlOperation(mutations.publishTaskRequest, {
          sub: this.sub,
          command: "TaskRequest",
          taskType: "GetPMSInfo",
        })
      );

      // smoke & mirrors ftw
      setTimeout(() => {
        this.requestingPmsInfoUpdate = false;
        this.pmsInfoUpdateRequested = true;
      }, 1500);
    },
  },
};
</script>